import {
  SCHEMA_ICON_PICKER_OPTIONS,
  resolveSchemaIconName,
  type SchemaIconPickerName,
} from '@reach/shared-types/schema-icon-picker';
import {
  Award,
  Bell,
  Box,
  Briefcase,
  Building2,
  Calendar,
  Car,
  CircleCheck,
  ClipboardList,
  Clock,
  Contact,
  CreditCard,
  Database,
  Dog,
  DollarSign,
  FileText,
  Flag,
  Gift,
  Hash,
  Heart,
  Home,
  Layers,
  Mail,
  MapPin,
  MessageSquare,
  Package,
  Phone,
  Receipt,
  ShoppingCart,
  Sparkles,
  Star,
  Store,
  Tag,
  Tags,
  Ticket,
  Truck,
  User,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/** Explicit imports keep lucide-react's `icons` barrel — every glyph — out of the bundle. */
const PICKER_ICONS = {
  User,
  Users,
  Contact,
  Briefcase,
  Building2,
  Home,
  Store,
  MapPin,
  ShoppingCart,
  Receipt,
  CreditCard,
  DollarSign,
  Package,
  Box,
  Truck,
  Car,
  Calendar,
  Clock,
  Ticket,
  Wrench,
  ClipboardList,
  FileText,
  Mail,
  MessageSquare,
  Phone,
  Bell,
  Tag,
  Tags,
  Hash,
  Flag,
  Star,
  Heart,
  Award,
  Gift,
  CircleCheck,
  Zap,
  Sparkles,
  Layers,
  Database,
  Dog,
} satisfies Record<SchemaIconPickerName, LucideIcon>;

export interface SchemaIconOption {
  name: SchemaIconPickerName;
  Icon: LucideIcon;
  label: string;
}

export const SCHEMA_ICON_OPTIONS: SchemaIconOption[] = SCHEMA_ICON_PICKER_OPTIONS.map(option => ({
  name: option.name,
  label: option.label,
  Icon: PICKER_ICONS[option.name],
}));

export function resolveSchemaIcon(name: string): LucideIcon | null {
  const resolvedName = resolveSchemaIconName(name);
  if (!resolvedName) return null;
  return PICKER_ICONS[resolvedName];
}

export const DEFAULT_SCHEMA_COLORS: string[] = [
  '#111827',
  '#ef4444',
  '#f97316',
  '#f59e0b',
  '#22c55e',
  '#10b981',
  '#06b6d4',
  '#3b82f6',
  '#6366f1',
  '#a855f7',
  '#ec4899',
  '#6b7280',
];

/** Matches the backend validation exactly — a 6-digit hex, no shorthand. */
export const SCHEMA_COLOR_HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;

export function isValidSchemaColor(value: string): boolean {
  return SCHEMA_COLOR_HEX_PATTERN.test(value);
}
